import { action, observable, runInAction, makeObservable } from 'mobx'
import { LegacyPublisherSearch } from '@App/stores/search/models/publisher-search'
import { isEmptyObject } from '@App/helpers/check-is-empty-object'
import { searchPublishersForRH } from '@App/api/routes/search'
import RootStore from '@App/stores/root-store'
import { PaginationBody } from '@Entities/pagination'

import { PublisherSearchResultModel, toPublisherSearchResultModel } from '@Entities/work/publisher-search-result-model'
import { PublisherSearchStoreLike } from '@App/stores/search/publisher-search-store-like'

export default class PublisherSearchStore implements PublisherSearchStoreLike {
    private rootStore: RootStore

    constructor(rootStore: RootStore) {
        makeObservable<PublisherSearchStore, '_publisherSearch' | '_isSearching' | '_publisherSearchModel'>(this, {
            _publisherSearch: observable,
            _isSearching: observable,
            _publisherSearchModel: observable,
            setPublisherSearch: action,
            searchPublishers: action,
            clearStore: action,
        })

        this.rootStore = rootStore
    }

    private _publisherSearch: LegacyPublisherSearch | undefined = {
        publisherName: '',
        publisherIpi: '',
    }

    private _isSearching = false

    private _publisherSearchModel: PublisherSearchResultModel = {
        count: 0,
        results: [],
    }

    private _publisherSearchPagination: PaginationBody = {
        page: 1,
        limit: 10,
    }

    get publisherSearch(): LegacyPublisherSearch | undefined {
        return this._publisherSearch
    }

    get isSearching(): boolean {
        return this._isSearching
    }

    get publisherSearchModel(): PublisherSearchResultModel {
        return this._publisherSearchModel
    }

    public setPublisherSearch(publisherSearch: LegacyPublisherSearch) {
        this._publisherSearch = publisherSearch
    }

    public async searchPublishers() {
        this._isSearching = true
        await this.routePublisherSearch()
    }

    public clearStore = () => {
        this._publisherSearchModel = {
            count: 0,
            results: [],
        }
        this._publisherSearch = {
            publisherIpi: '',
            publisherName: '',
        }
        this._publisherSearchPagination = {
            page: 1,
            limit: 5,
        }
        this._isSearching = false
    }

    private searchExists(): boolean {
        return !!(this._publisherSearch && !isEmptyObject(this._publisherSearch))
    }

    private async routePublisherSearch() {
        if (this.searchExists()) {
            const results = await searchPublishersForRH(
                this.rootStore.rightsholderStore.currentRightsholderId,
                this._publisherSearchPagination,
                this._publisherSearch
            )

            const publishers = toPublisherSearchResultModel(results.data)
            runInAction(() => {
                this._publisherSearchModel = publishers
                this._isSearching = false
            })
        } else {
            runInAction(() => {
                this._publisherSearchModel = {
                    count: 0,
                    results: [],
                }
                this._isSearching = false
            })
        }
    }
}
